import React, { useEffect } from "react";

const COUNTRY = { 1: "תורכיה", 2: "ישראל", 3: "מצרים" };
const WARE = { 1: "נחושת", 2: "זיתים", 3: "חיטה" };
const WARES = [1, 2, 3];
const COUNTRIES = [1, 2, 3];

const fmt = (n) => Math.trunc(n || 0).toLocaleString("en-US");
const signed = (n) => (n > 0 ? `+${fmt(n)}` : fmt(n));

const profitClass = (n) => {
  if (n > 0) return " profit-pos";
  if (n < 0) return " profit-neg";
  return "";
};

export default function ProfitHelper({ data, onClose }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!data) return null;

  const current = data.country;
  const freeCapacity = Math.max(0, Math.trunc(data.capacity - data.totalWeight));
  const fullCapacity = Math.trunc(data.capacity);
  const destinations = COUNTRIES.filter((c) => c !== current);
  return (
    <div className="admin-panel profit-panel" dir="rtl" data-testid="profit-panel">
      <div className="admin-head">
        <button className="rbtn small" data-testid="profit-close-btn" onClick={onClose}>
          → חזרה
        </button>
        <div className="admin-title">טבלת עזר לרווחים</div>
        <span className="admin-head-spacer" />
      </div>

      <div className="profit-body">
        <div className="profit-summary">
          <div>
            נמל נוכחי: <strong>{COUNTRY[current]}</strong>
          </div>
          <div>
            כסף: <strong>{fmt(data.money)}</strong> · קיבולת פנויה:{" "}
            <strong>{fmt(freeCapacity)}</strong>/{fmt(fullCapacity)} טון
          </div>
        </div>

        {destinations.map((dest) => (
          <section className="profit-dest" key={dest}>
            <div className="profit-dest-title">יעד: {COUNTRY[dest]}</div>
            <div className="profit-table-wrap">
              <table className="profit-table simple">
                <thead>
                  <tr>
                    <th>סחורה</th>
                    <th>בהתאם לקיבולת</th>
                    <th>ללא הגבלת קיבולת</th>
                  </tr>
                </thead>
                <tbody>
                  {WARES.map((ware) => {
                    const buy = data.prices[current][ware];
                    const sell = data.prices[dest][ware];
                    const perTon = sell - buy;
                    const affordable = buy > 0 ? Math.floor(data.money / buy) : 0;
                    // Column 1: realistic - bounded by current free capacity
                    const freeQty = Math.max(0, Math.min(affordable, freeCapacity));
                    // Column 2: ignore capacity entirely - just by available money
                    const moneyQty = Math.max(0, affordable);
                    const freeProfit = freeQty * perTon;
                    const moneyProfit = moneyQty * perTon;
                    const sameAsFree = freeQty === moneyQty;
                    return (
                      <tr key={ware}>
                        <td className="profit-ware">{WARE[ware]}</td>
                        <td className={profitClass(freeProfit)}>
                          <div className="profit-amt">{signed(freeProfit)}</div>
                          <div className="profit-qty">{fmt(freeQty)} טון</div>
                        </td>
                        <td
                          className={
                            profitClass(moneyProfit) + (sameAsFree ? " profit-same" : "")
                          }
                        >
                          <div className="profit-amt">{signed(moneyProfit)}</div>
                          <div className="profit-qty">{fmt(moneyQty)} טון</div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
        ))}

        <div className="profit-legend">
          <span>
            <b>בהתאם לקיבולת</b> = הכמות שניתן לקנות עכשיו עם הכסף הזמין
            ({fmt(data.money)} ש"ח) בגבולות הקיבולת הפנויה ({fmt(freeCapacity)} טון).
          </span>
          <span>
            <b>ללא הגבלת קיבולת</b> = הכמות שהכסף שלך מספיק לקנות, מבלי לקחת
            בחשבון את הקיבולת. הקיבולת ניתנת לפינוי על־ידי מכירה - הכסף לא.
          </span>
        </div>
      </div>
    </div>
  );
}
